import { Button } from '@mui/material'
import { DataGridProps, GridAlignment, GridColTypeDef } from '@mui/x-data-grid'
import { ISingleClient, LifecycleStatus, PaymentStatus, QuotationStatus } from '@typings'
import { useNavigate } from 'react-router-dom'
import { formatValueToCurrency } from './formatCentToAmount.helper'
import { StatusBadge } from 'src/components/features/status-badge/StatusBadge'

export interface IFormatColumnData {
  columns: DataGridProps['columns']
}

export const renderClientCell = (client?: ISingleClient) => {
  const navigate = useNavigate()

  if (!client) return '-'

  return (
    <Button
      variant="text"
      onClick={() =>
        navigate(`/klanten/${client.id}`, {
          state: { from: 'datagrid' },
        })
      }>
      {client.name}
    </Button>
  )
}

export const handleFormat = (type: GridColTypeDef['type']) => {
  switch (type) {
    case 'date':
    case 'dateTime':
      return {
        type: type,
        valueGetter: ({ value }: any) => {
          return value ? new Date(value) : undefined
        },
      }
    case 'currency':
      return {
        align: 'right' as GridAlignment,
        headerAlign: 'right' as GridAlignment,
        valueGetter: ({ value }: { value: number }) =>
          value !== 0 || typeof value === 'number' ? formatValueToCurrency(value) : '-',
      }
    case 'client':
      return {
        renderCell: ({ value }: { value?: ISingleClient }) => renderClientCell(value),
      }
    case 'lifecycle_status':
      return {
        renderCell: ({ value }: { value?: LifecycleStatus }) => (
          <StatusBadge
            status={value || null}
            type="lifecycle"
          />
        ),
      }
    case 'payment_status':
      return {
        renderCell: ({ value }: { value?: PaymentStatus }) => (
          <StatusBadge
            status={value || null}
            type="payment"
          />
        ),
      }
    case 'quotation_status':
      return {
        renderCell: ({ value }: { value?: QuotationStatus }) => (
          <StatusBadge
            status={value || null}
            type="quotation"
          />
        ),
      }
    default:
      return {}
  }
}

export const formatColumnData = (columns: DataGridProps['columns']) => {
  return columns.map(singleColumn => {
    const formatted = {
      ...singleColumn,
      headerClassName: 'ov-datagrid-header',
      ...handleFormat(singleColumn.type),
    }

    return formatted
  })
}
